import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["popoverUse", "size"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import UICloseButton from '../button/UICloseButton';
import { SMALL_CLOSE_BUTTON_SIZE, MEDIUM_CLOSE_BUTTON_SIZE, POPOVER_PADDING_X, POPOVER_PADDING_Y } from 'HubStyleTokens/sizes';
import { CALYPSO, EERIE, OLAF } from 'HubStyleTokens/colors';
import { USE_CLASSES } from './utils/Use';
import { toShorthandSize } from '../utils/propTypes/tshirtSize';
import { memo } from 'react';

/** @internal */

/** @internal */

/**
 * Reconciles type errors by removing `undefined` from a prop's type union
 * when a prop has a value set in `defaultProps`.
 * @internal
 */
import { jsx as _jsx } from "react/jsx-runtime";
const CLOSE_BUTTON_USE_COLOR_MAP = {
  default: EERIE,
  shepherd: OLAF,
  longform: CALYPSO,
  tooltip: OLAF,
  'tooltip-danger': OLAF,
  unstyled: EERIE
};
const StyledCloseButton = styled(UICloseButton).withConfig({
  displayName: "UIPopoverCloseButton__StyledCloseButton",
  componentId: "sc-1dkijca-0"
})(["position:relative;margin-left:", ";right:0;left:0;top:", ";"], ({
  size
}) => size === 'sm' ? SMALL_CLOSE_BUTTON_SIZE : MEDIUM_CLOSE_BUTTON_SIZE, ({
  size
}) => `${size === 'sm' ? 0 : parseInt(POPOVER_PADDING_X, 10) - parseInt(POPOVER_PADDING_Y, 10)}px`);
const UIPopoverCloseButton = /*#__PURE__*/memo(_ref => {
  let {
      popoverUse = 'default',
      size = 'md'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const computedColor = CLOSE_BUTTON_USE_COLOR_MAP[popoverUse];
  const shorthandSize = toShorthandSize(popoverUse === 'longform' ? 'sm' : size);
  return /*#__PURE__*/_jsx(StyledCloseButton, Object.assign({
    color: computedColor,
    size: shorthandSize
  }, rest));
});
const propTypes = {
  color: PropTypes.string,
  size: UICloseButton.propTypes.size,
  popoverUse: PropTypes.oneOf(Object.keys(USE_CLASSES))
};
UIPopoverCloseButton.propTypes = propTypes;
const defaultProps = {
  size: 'md',
  popoverUse: 'default'
};
UIPopoverCloseButton.defaultProps = defaultProps;
UIPopoverCloseButton.displayName = 'UIPopoverCloseButton';
export default UIPopoverCloseButton;